<template>
  <div class="home">
    <video
      v-if="compatible"
      :src="
        clientWidth > 900
          ? require('@/assets/reservation/KarosOnline_Open.mp4')
          : require('@/assets/reservation/KarosOnline_Open_phone.mp4')
      "
      autoplay
      muted
      loop
      x-webkit-airplay="true"
      x5-video-player-type="h5"
      webkit-playsinline=""
      playsinline="true"
      preload="none"
    ></video>
    <div class="img" v-if="clientWidth <= 900 && !compatible">
      <img src="@/assets/reservation/bg_m.jpg" alt="" />
    </div>
    <div class="wrapper">
      <div class="play" @click="showVideo = true">
        <img
          :src="
            clientWidth > 900
              ? require('@/assets/reservation/playbutton.png')
              : require('@/assets/reservation/playbutton_m.png')
          "
          alt=""
        />
      </div>
      <div class="slogan"><img src="@/assets/reservation/slogan.png" alt="" /></div>
      <div class="btn-box" v-if="clientWidth > 900">
        <!-- <div class="app">
          <img src="@/assets/reservation/app.png" alt="" />
          <div class="btn">
            <div class="btn-item" @click="appStore"></div>
            <div class="btn-item" @click="googleStore"></div>
          </div>
        </div> -->
        <div class="app" @click="slideTo2">
          <img src="@/assets/reservation/reservation_m.png" alt="" />
        </div>
      </div>
      <div class="btn-box" v-else>
        <div class="app" @click="slideTo2">
          <img src="@/assets/reservation/reservation_m.png" alt="" />
        </div>
      </div>
      <div class="img-splitline" @click="slideTo2">
        <img src="@/assets/reservation/img_splitline.png" alt="">
      </div>
    </div>
    <div class="playVideo" v-if="showVideo" ref="playVideo">
      <div class="playVideo-wrapper">
        <iframe
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          src="https://www.youtube.com/embed/EnJJJ_HkquY?autoplay=1&mute=1&playlist=EnJJJ_HkquY"
          frameborder="0"
        ></iframe>
        <div class="close" @click="showVideo = false">
          <img src="@/assets/reservation/close.png" alt="" />
        </div>
      </div>
    </div>
    <Dialog ref="Dialog" v-if="dialogvisible" @handleClose="close">{{
      dialogMsg
    }}</Dialog>
  </div>
</template>
<script>
import Dialog from "./Dialog";
export default {
  components: {
    Dialog,
  },
  data() {
    return {
      showVideo: false,
      clientWidth: document.body.clientWidth,
      compatible: false,
      dialogvisible: false,
      dialogMsg: "",
    };
  },
  mounted() {
    document.addEventListener("mouseup", (e) => {
      let playVideo = this.$refs.playVideo;
      let Dialog = this.$refs.Dialog;
      if (Dialog) {
        if (!Dialog.contains(e.target)) {
          this.dialogvisible = false;
        }
      }
      if (playVideo) {
        if (!playVideo.contains(e.target)) {
          this.showVideo = false;
        }
      }
    });
    window.addEventListener("resize", this.handleResize);
    let userAgent = navigator.userAgent;
    if (
      userAgent.indexOf("Firefox") > -1 ||
      (userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1) ||
      (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") === -1)
    ) {
      this.compatible = true;
    } else {
      this.compatible = false;
    }
  },
  destroyed() {
    document.removeEventListener("mouseup");
    window.removeEventListener("resize");
  },
  methods: {
    tag(event) {
      window.gtag("event", "conversion", {
        send_to: "AW-10796958810/L9wTCILCsbcDENqIspwo",
        value: 1.0,
        currency: "USD",
      });
      window.fbq("track", event, {
        value: 1.0,
        currency: "USD",
      });
      window.gtag("event", event);
    },
    googleStore() {
      window.open("https://lihi1.cc/g38hw", "_blank");
      this.tag("Lead");
    },
    handleResize() {
      this.clientWidth = document.body.clientWidth;
    },
    slideTo2() {
      this.$emit("fullPageSlide", 1);
    },
    close() {
      this.dialogvisible = false;
    },
    appStore() {
      this.dialogvisible = true;
      this.dialogMsg = "많은 기대 부탁드립니다!";
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .img {
    position: absolute;
    z-index: -1;
    width: 100%;
    height: 100vh;
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
  .wrapper {
    position: absolute;
    bottom: 8%;
    left: 50%;
    transform: translateX(-50%);
    width: 52.9%;
    margin: 0 auto;
  
    @media screen and (max-width: 900px) {
      width: 100%;
      bottom: 10vh;
    }
    .play {
      cursor: pointer;
      text-align: center;
      margin-bottom: 10px;
      @media screen and (max-width: 900px) {
        text-align: center;
        img {
          width: 20vw;
        }
      }
    }
    .slogan {
      width: 100%;
      text-align: center;
      margin-bottom: 20px;
      img{
        width: 100%;
        height: auto;
      }
      @media screen and (max-width: 900px) {
        text-align: center;
        img {
          width: 100%;
        }
      }
    }
    .img-splitline {
      margin-top: 20px;
      cursor: pointer;
      img{
        width: 100%;
        height: auto;
      }
    }
    .btn-box {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      grid-gap: 10px;
      @media screen and (max-width: 900px) {
        grid-gap: 10px;
        flex-direction: column;
      }
      .app {
        cursor: pointer;
        position: relative;
        text-align: center;
        img {
          max-width: 342px;
          height: auto;
        }
        @media screen and (max-width: 900px) {
          width: 100%;
          text-align: center;
          img {
            width: 260px;
            max-width: unset;
          }
        }
        .btn {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          flex-direction: column;
          &-item {
            width: 195px;
            height: 65px;
            border-radius: 8px;
          }
        }
      }
    }
  }
  .playVideo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50%;
    aspect-ratio: 1920/1080;
    z-index: 999;
    @media screen and (max-width: 900px) {
      width: 80%;
    }
    &-wrapper {
      width: 100%;
      height: 100%;
      position: relative;
      iframe {
        width: 100%;
        height: 100%;
      }
      video {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
      .close {
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 9;
        cursor: pointer;
      }
    }
  }
}
</style>
